module.exports = __webpack_public_path__ + "static/media/django.4a581c98.png";